import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layouts/dashboardLayout';
import AddProductForm from '../../components/forms/addProductForm';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch, } from 'react-redux';

let EditProduct = () => {
   let params = useParams(); 
   let [inputs, setInputs] = useState("")
   let products = useSelector(data => data.products);
   useEffect(() => {
      let product = products.data.filter(data => data._id == params.id);
      if (product) {
         console.log("product[0]", product[0])
         setInputs(product[0])
      }
   }, [products])
   return (
      <>
         <DashboardLayout>
            {inputs && (
               <AddProductForm inputs={inputs} />
            )}
         </DashboardLayout >
      </>
   )
}

export default EditProduct